import { AnyAction } from 'redux';
import * as ActionType from '../../actions/ActionTypes';

const initialState: IUserReducerState = {
    UserEmail: "",
    UserObject: {}
};

const userReducer = (oldState: IUserReducerState = initialState, action: AnyAction): IUserReducerState => {

    let newState = { ...oldState }
    switch (action.type) {
        case ActionType.SET_USER_EMAIL:
            // This is just an example, to setup the folder structure and provide some boilerplate implementation.
            newState.UserEmail = action.payload
            break;
        case ActionType.SET_USER_OBJECT:
            newState.UserObject = action.payload;
            break;
        case ActionType.SET_USER_ATTRIBUTES:
            newState.UserObject.attributes = action.payload;
            break;
    }

    return newState;
}

export default userReducer;